import { render } from "./identityInfo.vue?vue&type=template&id=3cb700fe&scoped=true"
import script from "./identityInfo.vue?vue&type=script&lang=js"
export * from "./identityInfo.vue?vue&type=script&lang=js"

import "./identityInfo.vue?vue&type=style&index=0&id=3cb700fe&lang=less&scoped=true"

import exportComponent from "D:\\workday\\code\\h5-moxigecash\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb700fe"]])

export default __exports__